import { render, staticRenderFns } from "./building.vue?vue&type=template&id=3c8b8b7c"
import script from "./building.vue?vue&type=script&lang=js"
export * from "./building.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports